import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ProspectService } from 'services/prospect.service';
import { EventEmitterService } from 'services/event-emitter.service';
import { CompressionService } from 'services/compression.service';
import { ErrorService } from 'services/error.service';
import { SplashService } from 'services/splash.service';
import { VerifastStatus } from 'app/interface/verifastStatus';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';

@Component({
  selector: 'app-verify-identity',
  templateUrl: './verify-identity.component.html',
  styleUrls: ['./verify-identity.component.css']
})
export class VerifyIdentityComponent implements OnInit {

  selfieFile: File = null;
  errorMessage: string = null;
  loading: boolean = true;

  constructor(private router: Router, private prospectService: ProspectService, private eventEmitterService: EventEmitterService, private compressionService: CompressionService, private errorService: ErrorService, private splashService: SplashService) {
    this.eventEmitterService.selfTourModalTextChange("Verify Identity");
  }

  ngOnInit() {
    this.splashService.updateSplash("selftour");
    this.prospectService.GetVerifastStatus(false, null).subscribe(res => this.onGetVerifastStatus(res));
  }

  onGetVerifastStatus(status: VerifastStatus) {
    if (status.IsVerified) {
      this.verifyLocation();
    }
    else {
      this.loading = false;
    }
  }

  takePhoto() {
    this.errorMessage = null;
    document.getElementById('selfieFile').click();
  }

  readUpload(fileInput: any) {
    this.errorMessage = null;

    if (fileInput.target.files && fileInput.target.files[0]) {
      var reader = new FileReader();

      reader.onload = function (e: any) {
        document.getElementById("uploadedSelfieImage").setAttribute("src", e.target.result);
      }

      reader.readAsDataURL(fileInput.target.files[0]);
      this.selfieFile = fileInput.target.files[0];
    }
  }

  verifyLocation() {
    if (!navigator.geolocation) {
      this.loading = false;
      this.errorMessage = 'Geolocation is not supported by your browser';
    } else {

      const options = {
        enableHighAccuracy: true,
        timeout: 15000,
        maximumAge: 0
      };

      navigator.geolocation.getCurrentPosition(res => this.usePhoto(res), err => this.geoLocationError(), options);
    }
  }

  geoLocationError() {
    this.errorMessage = "Unable to retrieve your location";
    this.loading = false;
  }

  async usePhoto(position: any) {
    this.errorMessage = null;
    this.loading = true;

    let yardiKey = localStorage.getItem('TourYardiKey');
    let tourKey = localStorage.getItem('SelfTourKey');

    if (yardiKey === null || yardiKey === undefined || tourKey === null || tourKey === undefined) {
      this.errorMessage = "Error pulling tour property.";
      this.loading = false;
    }
    else {
      let formData: FormData = new FormData();

      let file = this.selfieFile;
      if (file) {
        let compressedfile = await this.compressionService.compressImage(file, 4.8)
        formData.append('uploadFile', compressedfile, file.name);
      }
      formData.append('yardiKey', yardiKey);
      formData.append('tourKey', tourKey);
      formData.append('latitude', position.coords.latitude);
      formData.append('longitude', position.coords.longitude);
      this.prospectService.VerifyIdentity(formData).subscribe(res => this.onUsePhotoSuccess(res), err => this.onUsePhotoError(err));
    }
  }

  onUsePhotoSuccess(result: any) {
    this.loading = false;
    this.router.navigate(['/tour/selftour-start/verify-confirmed']);
  }

  onUsePhotoError(err: any) {
    if (err?.includes("photo")) {
      this.errorService.showError(err);
      this.loading = false;
      this.selfieFile = null;
    } else {
      this.router?.navigate(['/tour/selftour-start/error'], {
        state: {
          message: err ?? 'Unknown Error'
        }
      });
    }
  }
}
